var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99839 7.17923C5.76775 7.17923 3.95737 8.93108 3.95737 11.0896C3.95737 11.6684 4.08668 12.2158 4.32914 12.7007C4.3938 12.8415 4.46654 12.9744 4.54736 13.0996C5.24241 14.2336 6.52746 15 7.99839 15C9.46932 15 10.7544 14.2336 11.4494 13.0996C11.5302 12.9744 11.603 12.8415 11.6676 12.7007C11.9101 12.2158 12.0394 11.6684 12.0394 11.0896C12.0394 8.93108 10.229 7.17923 7.99839 7.17923Z",
    fill: "#15808c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9V13L9.5 11.6667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13L6.5 11.6667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6251 11.5121C14.3342 11.7624 14.019 11.9735 13.6795 12.1456C13.3886 12.2864 13.0976 12.0127 13.1461 11.6998C13.1784 11.473 13.1946 11.2384 13.1946 10.996C13.1946 8.19612 10.8346 5.91245 7.94127 5.91245C5.0479 5.91245 2.68794 8.19612 2.68794 10.996C2.68794 11.3557 2.72835 11.6998 2.80109 12.0361C2.85767 12.3098 2.63945 12.5836 2.35658 12.5132C-0.835827 11.7624 -0.851991 7.00736 2.72027 6.76491H2.76068C0.166346 -0.219037 11.1094 -3.01105 12.3622 4.32483C15.8617 4.75497 17.276 9.26756 14.6251 11.5121Z",
    fill: "#15808c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.4a3ba50c.svg";
export { ForwardRef as ReactComponent };